import Button from "components/Elements/Button/Button.js";
import Image from "components/Elements/Image/Image.tsx";
import React, { useState } from "react";
import Carousel from "react-simply-carousel";
import { useContent } from "contexts/contentContext/contentContext.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import { examplePagesListEn, examplePagesListHe } from "../Helpers.js";
import useMediaQueries from "hooks/useMediaQueries.js";
import config from "config";
import { LinkToNewTab } from "components/Elements/Link/Link.js";

const setFirstLetterCapital = (pageName) => {
  return pageName.charAt(0).toUpperCase() + pageName.slice(1);
};

const PageExampleSection = () => {
  const { getTextByKey, getLanguage, getDirection, getHtmlByKey } =
    useContent();
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const { newMobileCondition } = useMediaQueries();
  const langUrl = getLanguage() === "he" ? "he" : "en";

  const examplePagesList =
    getLanguage() === "he" ? examplePagesListHe : examplePagesListEn;

  const carouselItem = (item, i) => {
    return (
      <div
        key={i}
        className="carousel-item"
        style={{
          width: "430px",
          marginInline: "30px",
          direction: getDirection(),
        }}
      >
        <a
          href={`${config.baseurl}/${item.forceEn ? "en" : langUrl}/page/${
            item.link
          }`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="item-container" style={{ direction: getDirection() }}>
            <div className="image">
              <Image
                name={`embed-forms/${item.image}`}
                ext={item.ext}
                alt=""
                title=""
              />
            </div>
            <div className="item-details" style={{ direction: getDirection() }}>
              <h4 className="page-title" style={{ direction: getDirection() }}>
                {setFirstLetterCapital(getTextByKey(item.title))}
              </h4>
              <p
                style={{ direction: getDirection() }}
                className="page-description"
              >
                {getTextByKey(item.description)}
              </p>
            </div>
          </div>
        </a>
      </div>
    );
  };

  const carouselMobileItem = (item, i) => {
    return (
      <div
        key={i}
        className="carousel-item-mobile"
        style={{
          width: "300px",
          marginInline: "0px",
          direction: getDirection(),
        }}
      >
        <a
          href={`${config.baseurl}/${langUrl}/page/${item.link}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="item-container" style={{ direction: getDirection() }}>
            <div className="image">
              <Image
                name={`embed-forms/${item.image}`}
                ext={item.ext}
                alt=""
                title=""
              />
            </div>
            <div className="item-details" style={{ direction: getDirection() }}>
              <h4 className="page-title" style={{ direction: getDirection() }}>
                {getTextByKey(item.title)}
              </h4>
              <p className="page-description">
                {getTextByKey(item.description)}
              </p>
            </div>
          </div>
        </a>
      </div>
    );
  };

  // const scrollToCreatePageSection = () => {
  //   document
  //     .getElementById("create-embed-page-id")
  //     .scrollIntoView({ behavior: "smooth", block: "center" });
  // };

  const carouselMobile = () => {
    return (
      <div className="mobile-carousel">
        <Carousel
          infinite
          //centerMode
          updateOnItemClick
          containerProps={{
            style: {
              justifyContent: "space-between",
              width: "100vw",
            },
          }}
          activeSlideIndex={activeSlideIndex}
          onRequestChange={setActiveSlideIndex}
          forwardBtnProps={{
            children: (
              <div className="arrow arrow-right">
                <Icon iconClass="arrow-carousel" name="arrow-right" />
              </div>
            ),
            style: {
              width: 30,
              height: 15,
              alignSelf: "center",
            },
          }}
          backwardBtnProps={{
            children: (
              <div className="arrow arrow-left">
                <Icon iconClass="arrow-carousel" name="arrow-left" />
              </div>
            ),
            style: {
              width: 30,
              height: 15,
              alignSelf: "center",
            },
          }}
          //itemsToShow={1}
          speed={400}
        >
          {examplePagesList.map((item, i) => carouselMobileItem(item, i))}
        </Carousel>
        <div className="dots-container">
          {examplePagesList.map((item, i) => (
            <div
              className={`dot ${activeSlideIndex === i ? "active" : ""}`}
              key={i}
              onClick={() => setActiveSlideIndex(i)}
            >
              <i className="fas fa-circle"></i>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="page-examples">
      <div className="header-section">
        <h2>{getHtmlByKey("jumbo-forms-example-pages-title")}</h2>
        <p>{getHtmlByKey("jumbo-forms-example-pages-text1")}</p>
        <span>{getHtmlByKey("jumbo-forms-example-pages-text2")}</span>
      </div>
      {newMobileCondition ? (
        carouselMobile()
      ) : (
        <div className="carousel-container">
          <Carousel
            infinite
            updateOnItemClick
            centerMode
            containerProps={{
              style: {
                justifyContent: "space-between",
                maxWidth: "100%",
              },
            }}
            activeSlideIndex={activeSlideIndex}
            onRequestChange={setActiveSlideIndex}
            forwardBtnProps={{
              children: (
                <div className="arrow arrow-right">
                  <Icon iconClass="arrow-carousel" name="arrow-right" />
                </div>
              ),
              style: {
                width: 100,
                height: 50,
                alignSelf: "center",
              },
            }}
            backwardBtnProps={{
              children: (
                <div className="arrow arrow-left">
                  <Icon iconClass="arrow-carousel" name="arrow-left" />
                </div>
              ),
              style: {
                width: 100,
                height: 50,
                alignSelf: "center",
              },
            }}
            itemsToShow={3}
            speed={400}
          >
            {examplePagesList.map((item, i) => carouselItem(item, i))}
          </Carousel>
          <div className="dots-container">
            {examplePagesList.length > 3 &&
              examplePagesList.slice(0, 6).map((item, i) => (
                <div
                  className={`dot ${activeSlideIndex === i ? "active" : ""}`}
                  key={i}
                  onClick={() => setActiveSlideIndex(i)}
                >
                  <i className="fas fa-circle" />
                </div>
              ))}
          </div>
        </div>
      )}
      <div className="footer-section">
        <LinkToNewTab page="user/jumbo-forms/form-management">
          <Button
            id="forms-marketing_example-pages_get-one"
            className="new-button embed-button"
          >
            {getTextByKey("try-it")}
          </Button>
        </LinkToNewTab>
      </div>
    </div>
  );
};

export default PageExampleSection;
